export const doublebyteChecker = input => {
  const kanjiRegex = /[\u4E00-\u9fbf]/;
  return kanjiRegex.test(input);
};

/**
 * Check:
 * - kanji double byte symbols.
 * - double byte Alphanumeric and special symbols.
 * exclude:
 * - half-width Kanji symbols
 */
export const fullDoubleByteChecker = input => {
  const fullDoubleByteRegex =
    /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FBF\uFF01-\uFF5E]/;
  return fullDoubleByteRegex.test(input);
};
